import { CustomContainer } from "src/style";
import { AppCenterPopupD2, CenterPopupHeaderD2, NotificationLayout } from "src/component";

export const NotificationPopD2: React.FC<any> =({close}) => {
    
    return (
        <AppCenterPopupD2 
            height='87' zIndex='6' 
            close={close} 
            overflow='hidden'
        >
            <CenterPopupHeaderD2 title='Notification' close={close} />
            <CustomContainer 
                height="87"
                style={{maxHeight: '90%'}}
                className="popup-content-container"
            >
                <NotificationLayout isD3 />
            </CustomContainer>
        </AppCenterPopupD2>
    )
}  